import { canPurchaseProduct, hasProductExposure, showExposurePrice } from "../../../../Component/tool/productExposure";
import { joinRestockWait } from '../RestockWaitPanel';
import ModalCloseButton from '../../../../Component/UI/ModalCloseButton';
import UserModalHeader from '../../../../Component/UI/UserModalHeader';

/* eslint-disable react/jsx-pascal-case */
import axios, { AxiosError } from "axios";
import React, { useEffect, useRef, useState } from "react";
import { submitPurchase } from './purchaseRequest';
import ProductThumbnail from '../../../../Component/UI/ProductThumbnail';
import type { InventoryUpdate } from '../inventory';
import styled, { keyframes } from "styled-components";
import api from "../../../../Component/axios_Interceptor/api";
import url from "../../../../Component/server";
import { Icon, RowView, CenterView } from "../../../../Component/style/common_style";
import { amountFormat } from "../../../../Component/tool/Tools";
import Buy_Complete_Modal from "./Buy_Complete_Modal";
import Basic_Modal from "./Basic_Modal";
import { pushPurchaseGtmEvent } from "../../../../Component/analytics/gtm";

interface OptionProps {
  $select: boolean;
}

type props_data_type = {
  seq: number;
  live_seq: number;
  name: string;
  price: number;
  option_check: string;
  init_cnt: number;
  current_cnt: number;
  product_status: string;
  exposure_active?: boolean | null;
  exposure_price_mode?: 'visible' | 'seller' | 'hidden';
  product_num: number | null;
  unique_option1: string[];
  unique_option2: string[];
};

interface Buy_ModalProps {
  couponAccess?: import("../useLiveCouponProducts").LiveCouponAccess;
  visible: boolean;
  handleModal: React.Dispatch<React.SetStateAction<boolean>>;
  item: props_data_type | null | undefined;
  seq: number;
  load_productList?: () => Promise<void>; // 선택적 함수
  type: string;
  sellerId?: string | number;
  imageUrl?: string;
  onPurchaseComplete?: () => void;
  onOrderConfirmed?: () => void;
  inventoryUpdate?: InventoryUpdate;
  inventorySyncVersion?: number;
  canWait?: boolean;
  waitingGroups?: string[];
  onWaitJoined?: (group: string) => void;
}

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;
const slideDown = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;
const BackgroundArea = styled.div<{ $visible: boolean; $isOpen: boolean }>`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  position: fixed;
  inset: 0;
  display: ${(props) => (props.$visible ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  transition: opacity 0.5s ease;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  z-index: 99;
`;
const ModalBox = styled.div<{ $isOpen: boolean }>`
  box-sizing: border-box;
  width: 100%;
  max-width: 500px;
  background-color: var(--user-surface);
  color: var(--user-text);
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  max-height: min(800px, 85dvh);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: absolute;
  bottom: 0px;
  animation: ${(props) => (props.$isOpen ? slideUp : slideDown)} 0.5s ease;
  color: var(--user-text);
`;
const BtnArea = styled(RowView)`
  border-width: 0px;
  width: 100%;
  padding: 0px;
  margin-top: 1.5rem;
  flex: none;
  box-sizing: border-box;
  padding: 25px 25px calc(25px + env(safe-area-inset-bottom));
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 20px;
  font-family: var(--font-Pretendard-SemiBold);
  text-align: center;
  cursor: pointer;
  color: white;
  background: linear-gradient(90deg, #7955f0, #3209b9);
  &:disabled {
    cursor: not-allowed;
    background: var(--user-surface-raised);
    color: var(--user-text-muted);
  }
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: -4px; }
`;
const Content_Box = styled.div`
  width: 100%;
  padding: 20px 30px 8px;
  min-height: 0;
  flex: 0 1 auto;
  overflow-y: auto;
  overscroll-behavior: contain;
  position: relative;
  box-sizing: border-box;
  font-size: 14px;
`;
const Item_Box = styled.div`
  background-color: var(--user-surface-raised);
  border-radius: 8px;
  width: 100%;
  padding: 22px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
  box-sizing: border-box;
`;

const Item_Thumbnail = styled(ProductThumbnail)`
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  border-radius: 6px;
`;

const Item_Details = styled.div`
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
  .price {
    color: var(--user-error);
    margin-top: 3px;
  }
`;

const PurchaseCaution = styled.p`
  margin: 5px 0 0;
  color: var(--user-error);
  font-size: 13px;
  line-height: 1.5;
`;

const Option_Box = styled.div`
  box-sizing: border-box;
  display: flex;
  position: relative;
  flex-direction: column;
  overflow: auto;
  margin-top: 30px;
  width: 100%;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
`;
const Option_List_Box = styled.div`
  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const Option_Choices = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Option_Choice = styled.button<OptionProps>`
  min-height: 44px;
  border-radius: 8px;
  border: 1px solid ${(props) => (props.$select ? "var(--user-accent)" : "var(--user-border)")};
  background-color: ${(props) => (props.$select ? "var(--user-accent-soft)" : "var(--user-surface-muted)")};
  padding: 8px 12px;
  color: ${(props) => (props.$select ? "var(--user-accent)" : "var(--user-text)")};
  font: inherit;
  font-size: 14px;
  cursor: pointer;
  &:disabled {
    border-color: var(--user-border);
    background: var(--user-surface-raised);
    color: var(--user-text-muted);
    cursor: not-allowed;
  }
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
  &:hover:not(:disabled) { border-color: var(--user-accent); }
`;

const Reset_Btn = styled.button`
  align-self: center;
  flex-shrink: 0;
  margin-left: auto;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  border-color: var(--user-border);
  border-style: solid;
  border-width: 1px;
  background: var(--user-surface);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
  img { filter: var(--user-icon-filter); }
`;
const Count_Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  margin-top: 30px;
  width: 100%;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
`;
const Count_Heading = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
`;
const Stock_Badge = styled.div<{ $empty: boolean }>`
  padding: 8px 12px;
  border: 1px solid ${({ $empty }) => $empty ? 'var(--user-error)' : 'var(--user-accent)'};
  border-radius: 8px;
  background: ${({ $empty }) => $empty ? 'var(--user-error-soft)' : 'var(--user-accent-soft)'};
  color: ${({ $empty }) => $empty ? 'var(--user-error)' : 'var(--user-accent)'};
  font-family: var(--font-Pretendard-Bold);
  font-size: 18px;
  line-height: 1.3;
  white-space: nowrap;
`;
const QuantitySteps = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  width: 240px;
  max-width: 100%;
`;
const QuantityStep = styled.button`
  min-height: 44px;
  padding: 0 8px;
  border: 1px solid var(--user-border);
  border-radius: 8px;
  background: var(--user-surface-raised);
  color: var(--user-text);
  font: inherit;
  cursor: pointer;
  &:disabled { opacity: 0.4; cursor: not-allowed; }
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
`;
const Counter = styled.div`
  padding: 4px 8px;
  width: 164px;
  max-width: 100%;
  display: flex;
  position: relative;
  box-sizing: border-box;
  border-width: 1px;
  border-color: var(--user-border);
  border-style: solid;
  border-radius: 8px;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  color: var(--user-text-muted);
`;

const Counter_Btn = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  min-width: 44px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &:disabled { opacity: 0.4; cursor: not-allowed; }
  color: var(--user-text);
  font-size: 28px;
  line-height: 1;

  cursor: pointer;
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
`;
type option_type2 = {
  option1: string[];
  option2: string[];
  options: {
    seq: number;
    product_seq: number;
    option1: string;
    option2: string;
    init_cnt: number;
    current_cnt: number;
  }[];
};

const Buy_Modal = (props: Buy_ModalProps) => {

  const { visible, handleModal } = props;
  const priceVisible = !hasProductExposure(props.item) || showExposurePrice(props.item?.exposure_price_mode);
  const [isLoading, set_IsLoading] = useState(false);
  const submitting = useRef(false);
  const joiningWait = useRef(false);
  const [submittedWait, setSubmittedWait] = useState<string | null>(null);

  const completed = useRef(false);
  const optionRequestRef = useRef(0);
  const hasOptions = props.item?.option_check === 'y';

  useEffect(() => {
    let closeTimer: ReturnType<typeof setTimeout> | undefined;
    completed.current = false;
    setSubmittedWait(null);
    setLiveStock(props.item?.current_cnt ?? null);
    set_Option_data(undefined);
    Reset();
    if (visible && !priceVisible) {
      handleModal(false);
      return;
    }
    if (visible) {
      handleModal(true);
      product_option_info();
    } else {
      closeTimer = setTimeout(() => handleModal(false), 500);
    }
    return () => {
      clearTimeout(closeTimer);
      optionRequestRef.current += 1;
    };
  }, [visible, props.item?.seq, hasOptions, priceVisible]);

  useEffect(() => {
    if (visible && props.inventorySyncVersion) product_option_info(true);
  }, [props.inventorySyncVersion]);

  const closeModal = () => {
    if (submitting.current) return;
    handleModal(false);
  };

  const [option_data, set_Option_data] = useState<option_type2>();
  const inventoryRef = useRef(props.inventoryUpdate);

  const [select_option, set_Select_Option] = useState("");
  const [select_option2, set_Select_Option2] = useState("");
  const [option_seq, set_Option_Seq] = useState<number>(0);
  const waitGroup = `${props.item?.live_seq}:${props.item?.seq}:${props.item?.option_check === 'y' ? option_seq : 0}`;
  const alreadyWaiting = submittedWait === waitGroup || props.waitingGroups?.includes(waitGroup);
  const [count, set_Count] = useState(1);
  const [liveStock, setLiveStock] = useState<number | null>(null);
  const hasFirstOption = option_data?.option1.some(value => value !== "") ?? false;
  const hasSecondOption = option_data?.options.some(option => option.option1 === select_option && option.option2 !== "") ?? false;
  const selectedStock = option_data?.options.find(option => option.seq === option_seq)?.current_cnt;
  const fixedGift = props.couponAccess?.quantityLimitFor(Number(props.item?.seq)) === 1;
  const currentStock = hasOptions
    ? selectedStock ?? 0
    : liveStock ?? props.item?.current_cnt ?? 0;
  const forcedSoldOut = ['품절', '품절노출'].includes(props.item?.product_status ?? '');
  const canWaitForStock = props.canWait;
  useEffect(() => {
    set_Count(previous => currentStock <= 0 ? 0 : fixedGift ? 1 : Math.min(Math.max(previous, 1), currentStock));
  }, [currentStock, visible, fixedGift]);
  const sold_out = forcedSoldOut || (hasOptions
    ? option_seq > 0 && currentStock === 0
    : currentStock === 0);
  useEffect(() => {
    const update = props.inventoryUpdate;
    inventoryRef.current = update;
    if (!update || update.productSeq !== props.item?.seq) return;
    setLiveStock(update.currentCnt);
    set_Option_data(previous => previous && ({
      ...previous,
      options: previous.options.map(option => ({
        ...option,
        current_cnt: update.options.find(changed => changed.seq === option.seq)?.currentCnt ?? option.current_cnt,
      })),
    }));
  }, [props.inventoryUpdate, props.item?.seq]);
  const [isStockAlertOpen, setIsStockAlertOpen] = useState(false);

  const handleChange = (value: string, availableOptions = option_data) => {
    const selectedItem = availableOptions?.options.find(
      option => option.option1 === value && option.current_cnt > 0
    ) ?? (canWaitForStock ? availableOptions?.options.find(option => option.option1 === value) : undefined);
    set_Select_Option(value);
    set_Select_Option2(selectedItem?.option2 ?? "");
    set_Option_Seq(selectedItem?.seq ?? 0);
    set_Count(1);
  };

  const handleChange2 = (value: string) => {
    set_Select_Option2(value);
    set_Count(1);

    const selectedItem = option_data?.options.find(
      (item) =>
        item.option1 === select_option && item.option2 === value && (item.current_cnt > 0 || canWaitForStock)
    );
    set_Option_Seq(selectedItem?.seq ?? 0);
  };

  const Reset = (availableOptions?: option_type2) => {
    const single = availableOptions?.options.length === 1 ? availableOptions.options[0] : undefined;
    set_Select_Option(single?.option1 ?? "");
    set_Select_Option2(single?.option2 ?? "");
    set_Option_Seq(single?.seq ?? 0);
    set_Count(1);
  };

  const changeCount = (delta: number) => {
    if (fixedGift) return;
    set_Count(previous => currentStock <= 0 ? 0 : Math.min(currentStock, Math.max(1, previous + delta)));
  };

  // 옵션 정보 불러오기
  const product_option_info = (preserveSelection = false) => {
    if (!visible || !priceVisible || !hasOptions || !props.item) return;
    const requestId = ++optionRequestRef.current;
    const inventoryAtStart = inventoryRef.current;
    axios
      .get(url.Communication_url.product_option_info, {
        params: {
          product_seq: props.item?.seq,
        },
      })
      .then(function (response) {
        if (requestId !== optionRequestRef.current) return;
        if (response.data.option1.length !== 0) {
          const update = inventoryRef.current !== inventoryAtStart ? inventoryRef.current : undefined;
          const freshOptions: option_type2 = update && update.productSeq === props.item?.seq
            ? { ...response.data, options: response.data.options.map((option: option_type2['options'][number]) => ({
                ...option, current_cnt: update.options.find(changed => changed.seq === option.seq)?.currentCnt ?? option.current_cnt,
              })) }
            : response.data;
          set_Option_data(freshOptions);

          // A single first option opens its second options immediately.
          const opt1 = freshOptions.option1;
          if (!preserveSelection || !option_data) {
            if (freshOptions.options.length === 1) Reset(freshOptions);
            else if (opt1.length === 1 && freshOptions.options.some(option => option.option1 === opt1[0] && (option.current_cnt > 0 || canWaitForStock))) {
              handleChange(opt1[0], freshOptions);
            }
          }
        } else {
          set_Option_data(undefined);
        }
      })
      .catch(function (error) {
        if (requestId !== optionRequestRef.current) return;
        // console.log("get_product_option_info error : ", error);
        set_Option_data(undefined);
      });
  };

  // 주문하기
  const buy = async () => {
    if (!canPurchaseProduct(props.item)) return;
    if (submitting.current || completed.current || (props.couponAccess && !props.couponAccess.canPurchase(Number(props.item?.seq)))) return;
    const purchaseCount = fixedGift ? 1 : count;
    set_IsLoading(true);
    if (hasOptions && !option_data) {
      set_Basic_Modal_text('옵션 재고를 불러오지 못했습니다. 구매창을 다시 열어주세요.');
      open_Basic_Modal();
      set_IsLoading(false);
      return;
    }
    if (hasOptions && option_data !== undefined) {
      if (
        option_data.option1.length > 0 &&
        option_data.option1[0] !== "" &&
        select_option === ""
      ) {
        // alert("옵션을 선택해주세요.");
        set_Basic_Modal_text("옵션을 선택해주세요.");
        open_Basic_Modal();
        set_IsLoading(false);
        return;
      }
      if (
        hasSecondOption &&
        select_option2 === ""
      ) {
        // alert("옵션을 선택해주세요.");
        set_Basic_Modal_text("옵션을 선택해주세요.");
        open_Basic_Modal();
        set_IsLoading(false);
        return;
      }
    }

    // 재고량 초과 검증
    const maxStock = currentStock;

    if (purchaseCount > maxStock) {
      setIsStockAlertOpen(true);
      set_IsLoading(false);
      return;
    }
    if (purchaseCount === 0) {
      // alert("수량을 선택해주세요.");
      set_Basic_Modal_text("수량을 선택해주세요.");
      open_Basic_Modal();
      set_IsLoading(false);
    } else {
      try {
        submitting.current = true;

        await submitPurchase({
          live_seq: Number(props.item?.live_seq),
          product_seq: Number(props.item?.seq),
          option_seq: hasOptions ? option_seq : null,
          order_cnt: purchaseCount,
        });

        if (props.sellerId && props.item) {
          void api.get(url.Communication_url.user_info).then(({ data: user }) => {
            if (!user?.userid) return;
            pushPurchaseGtmEvent({
              sellerId: props.sellerId!, userId: user.userid, name: props.item!.name,
              productNumber: Number(props.item!.seq), unitPrice: Number(props.item!.price), count: purchaseCount,
              image: props.imageUrl,
            });
          }).catch(() => undefined);
        }

        completed.current = true;
        props.onOrderConfirmed?.();
        if (props.onPurchaseComplete) {
          handleModal(false);
          props.onPurchaseComplete();
        }
        else handleBuyComp();
      } catch (err) {
        if (err instanceof AxiosError && err.response) {
          const errRes = err.response.data;
          // alert(errRes.message);
          set_Basic_Modal_text(errRes.message);
          open_Basic_Modal();
        }
        if (!(err instanceof AxiosError && err.response)) {
          set_Basic_Modal_text(err instanceof Error ? err.message : '구매 결과를 확인하지 못했습니다. 다시 확인해주세요.');
          open_Basic_Modal();
        }
      } finally {
        submitting.current = false;
        set_IsLoading(false);
        props.load_productList && props.load_productList();
      }
    }
  };

  // 완료 모달
  const [BuyCompModal, setBuyCompModal] = useState(false);
  const handleBuyComp = () => setBuyCompModal(!BuyCompModal);
  const [BasicModal, set_BasicModal] = useState(false);
  const open_Basic_Modal = () => set_BasicModal(!BasicModal);
  const [basic_modal_text, set_Basic_Modal_text] = useState("");  const optionReset = (select_option || select_option2) && <Reset_Btn type="button" aria-label="옵션 초기화" onClick={() => Reset(option_data)}>
    <Icon src={require("../../../../Image/ic_reset_black.png")} alt="" />
  </Reset_Btn>;


  if (!priceVisible) return null;

  return (
    <BackgroundArea $visible={visible} $isOpen={visible} translate="no"
      onClick={event => { if (event.target === event.currentTarget) closeModal(); }}>
      <ModalBox $isOpen={visible} role="dialog" aria-modal="true" aria-label="구매하기" onClick={(e: any) => e.stopPropagation()}>
        <UserModalHeader title="구매하기" onClose={closeModal} />
        <Content_Box>
          <Item_Box>
            {props.imageUrl?.trim() && <Item_Thumbnail src={props.imageUrl} alt={`${props.item?.name || '상품'} 이미지`} />}
            <Item_Details>
              <div>{props.item?.name}</div>
              <div className="price">{amountFormat(props.couponAccess?.priceFor(Number(props.item?.seq), Number(props.item?.price)) ?? props.item?.price)}원</div>
            </Item_Details>
          </Item_Box>
          <PurchaseCaution>
            *구매하기는 장바구니에 담는 개념이 아닙니다. 신중 구매 부탁드립니다.
          </PurchaseCaution>
          <Option_Box
            style={!hasOptions ? { display: "none" } : {}}
          >
            옵션
            <Option_List_Box>
              {hasFirstOption && <div>
                <Option_Choices role="group" aria-label="첫 번째 옵션">
                  {option_data?.option1.filter(Boolean).map(item => {
                    const remaining = option_data.options.filter(option => option.option1 === item)
                      .reduce((sum, option) => sum + option.current_cnt, 0);
                    return <Option_Choice key={item} type="button" $select={select_option === item}
                      aria-pressed={select_option === item} disabled={remaining <= 0 && !canWaitForStock} onClick={() => handleChange(item)}>
                      {item}{forcedSoldOut || remaining <= 0 ? ' · 품절' : remaining < 10 ? ' · 품절임박' : ''}
                    </Option_Choice>;
                  })}
                </Option_Choices>
              </div>}
              {hasSecondOption && (!hasFirstOption || select_option !== "") && <div>
                <Option_Choices role="group" aria-label="두 번째 옵션">
                  {Array.from(new Set(option_data?.options
                    .filter(option => option.option1 === select_option && option.option2 !== "")
                    .map(option => option.option2))).map(item => {
                    const remaining = option_data?.options.filter(option => option.option1 === select_option && option.option2 === item)
                      .reduce((sum, option) => sum + option.current_cnt, 0) ?? 0;
                    return <Option_Choice key={item} type="button" $select={select_option2 === item}
                      aria-pressed={select_option2 === item} disabled={remaining <= 0 && !canWaitForStock} onClick={() => handleChange2(item)}>
                      {item}{forcedSoldOut || remaining <= 0 ? ' · 품절' : remaining < 10 ? ' · 품절임박' : ''}
                    </Option_Choice>;
                  })}
                </Option_Choices>
              </div>}
              {canWaitForStock && sold_out && optionReset}
            </Option_List_Box>
          </Option_Box>
          {!(canWaitForStock && sold_out) && <Count_Box>
            <Count_Heading>
              <span>수량</span>
              {fixedGift ? <output aria-label="선택 수량">1개 (증정)</output> : <Counter>
                <Counter_Btn type="button" aria-label="수량 줄이기" onClick={() => changeCount(-1)} disabled={count <= 1}>
                  <span aria-hidden="true">‹</span>
                </Counter_Btn>
                <output aria-label="선택 수량">{count}개</output>
                <Counter_Btn type="button" aria-label="수량 늘리기" onClick={() => changeCount(1)} disabled={currentStock <= count}>
                  <span aria-hidden="true">›</span>
                </Counter_Btn>
              </Counter>}
              {optionReset}
            </Count_Heading>
            {!fixedGift && <QuantitySteps role="group" aria-label="수량 빠른 조절">
              {[-5, -3, 3, 5].map(delta => <QuantityStep key={delta} type="button"
                aria-label={`수량 ${Math.abs(delta)}개 ${delta < 0 ? '줄이기' : '늘리기'}`}
                onClick={() => changeCount(delta)} disabled={delta < 0 ? count <= 1 : currentStock <= count}>
                {delta > 0 ? `+${delta}` : delta}
              </QuantityStep>)}
            </QuantitySteps>}
            {!hasOptions && (forcedSoldOut || currentStock < 10) && <Stock_Badge role="status" aria-live="polite" $empty={forcedSoldOut || currentStock <= 0}>{forcedSoldOut || currentStock === 0 ? '품절' : '품절임박'}</Stock_Badge>}
          </Count_Box>}
        </Content_Box>
        {canWaitForStock && (forcedSoldOut || currentStock <= 0) ? <WaitActions>
          <WaitButton as="button" disabled={isLoading || alreadyWaiting || (hasOptions && !option_seq)} onClick={async () => {
          if (joiningWait.current || alreadyWaiting) return;
          joiningWait.current = true;
          set_IsLoading(true);
          try { await joinRestockWait(Number(props.item?.live_seq), Number(props.item?.seq), hasOptions ? option_seq : null, 1);
            setSubmittedWait(waitGroup); props.onWaitJoined?.(waitGroup);
            closeModal();
          } catch (cause: any) { set_Basic_Modal_text(cause?.response?.data?.message || '대기 신청을 처리하지 못했습니다.'); open_Basic_Modal(); }
          finally { joiningWait.current = false; set_IsLoading(false); }
        }}>{alreadyWaiting ? '대기 중' : '대기'}</WaitButton>
        </WaitActions> : <BtnArea
          as="button"
          onClick={buy}
          disabled={!canPurchaseProduct(props.item) || isLoading === true || count === 0 || sold_out === true || Boolean(props.couponAccess && !props.couponAccess.canPurchase(Number(props.item?.seq)))}
        >
          {isLoading ? "구매 확인 중…" : sold_out ? "품절" : canPurchaseProduct(props.item) ? "구매하기" : "판매예정"}
        </BtnArea>}
      </ModalBox>
      <Buy_Complete_Modal
        visible={BuyCompModal}
        handleModal={handleBuyComp}
        onClose={closeModal}
      />
      <Basic_Modal
        visible={BasicModal}
        handleModal={set_BasicModal}
        text={basic_modal_text}
        onClose={closeModal}
        type={props.type}
      />
      {/* 재고 부족 경고 모달 */}
      {isStockAlertOpen && (
        <AlertOverlay onClick={() => setIsStockAlertOpen(false)}>
          <AlertBox onClick={(e) => e.stopPropagation()}>
            <AlertHeader>
              <div>재고 부족</div>
              <AlertExitBtn aria-label="재고 부족 안내 닫기" onClick={() => setIsStockAlertOpen(false)} />
            </AlertHeader>
            <AlertContent>
              최대 <span className="red">{currentStock}</span>개 구매가능해요.
            </AlertContent>
            <AlertConfirmBtn onClick={() => setIsStockAlertOpen(false)}>
              확인
            </AlertConfirmBtn>
          </AlertBox>
        </AlertOverlay>
      )}
    </BackgroundArea>
  );
};

export default Buy_Modal;

const WaitActions = styled.div`
  display: flex; align-items: center; gap: 12px; flex: none;
  padding: 16px 16px calc(16px + env(safe-area-inset-bottom));
`;
const WaitButton = styled(BtnArea)`
  flex: 1; width: auto; min-height: 48px; margin: 0; padding: 12px 16px; border-radius: 8px;
`;

const AlertOverlay = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .32);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const AlertBox = styled.div`
  border: 1px solid var(--user-border);
  box-sizing: border-box;
  width: 85%;
  max-width: 320px;
  background-color: var(--user-surface-raised);
  border-radius: 16px;
  overflow: hidden;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
`;

const AlertHeader = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: var(--font-Pretendard-Bold);
  border-bottom: 1px solid var(--user-border);
  color: var(--user-text);
`;

const AlertExitBtn = styled(ModalCloseButton)`  position: absolute;
  right: 20px;
`;

const AlertContent = styled.div`
  padding: 30px 20px;
  font-size: 15px;
  color: var(--user-text);
  font-family: var(--font-Pretendard-Medium);
  text-align: center;
  span.red {
    color: var(--user-error);
    font-family: var(--font-Pretendard-Bold);
  }
`;

const AlertConfirmBtn = styled(CenterView)`
  background: linear-gradient(135deg, #7955F0, #3209B9);
  color: white;
  font-size: 15px;
  font-family: var(--font-Pretendard-SemiBold);
  width: calc(100% - 40px);
  height: 44px;
  border-radius: 8px;
  cursor: pointer;
  &:active {
    opacity: 0.8;
  }
`;
